import type { DashboardProps } from './Dashboard.types';

export const useDashboard = (props: DashboardProps) => {
  return { ...props };
};
